
import { get } from 'http';

export default {
  data() {
    return {
      errorMessage: '',
      form : {
                id : '',
                indikator : '',
                file : null,
                tahun : '',
                catatan : '',
                createAt : '',
                editedAt : '',
                nik : '',
                passphrase : '',
                koordinat : '€',
                file_old : null
            },

      tahun : '',
      unit : '',
      unitKerja : '',
      unit_lppd : '',
      outcome : '',
      nik : '',
     
      list_data : [],
      list_tahun : [],
      list_unit : [],
      file_path: this.$store.state.url.URL_APP + "uploads/",

      page_first: 1,
      page_last: 0,
      cari_value: "",
      cek_load_data : true,

      mdl_add: false,
      mdl_edit: false,
      mdl_catat: false,
      mdl_catatan: false,
      mdl_tte: false,
      mdl_hapus : false,
      btn_add: false,
      mdl_open: false,

    }
  },
  watch: {
      form: {
          handler() {
              this.errorMessage = "";
          },
          deep: true
      }
    },
  methods: {

    getView : function(){
      console.log("NIKNIKNIK"+this.nik);
      this.$store.commit("shoWLoading");
      if (this.unit_lppd == '1') {
          this.outcome = 'viewAdmin'
      } else {
          this.outcome ='view'
      }
      fetch(this.$store.state.url.URL_OUT_COME + this.outcome, {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              cari_value: this.cari_value,
              tahun : this.tahun,
              unit : this.unit,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jml_data;
              this.$store.commit("hideLoading");
              console.log(res_data);
      });
    },

    getUnit : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Unit+"view", {
          method: "GET",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          }
      })
          .then(res => res.json())
          .then(res_data => {
              console.log(res_data);
              this.list_unit = res_data;
              this.$store.commit("hideLoading");
      });
    },

    getTahun : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Tahun, {
          method: "GET",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          }
      })
          .then(res => res.json())
          .then(res_data => {
              console.log(res_data);
              this.list_tahun = res_data;
              this.$store.commit("hideLoading");
      });
    },

    addData : function() {
      console.log(this.form);
      var formData = new FormData();
      formData.append('data', JSON.stringify(this.form))
      formData.append('file', this.form.file)
      fetch(this.$store.state.url.URL_OUT_COME + "addData", {
          method: "POST",
          headers: {
            // "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: formData
      }).then(res_data => {
          this.Notify('Sukses Menambah Data', 'light-blue-4', 'check_circle_outline');
          console.log(res_data);
          this.getView();
      });
    },


    editData : function(){
      var formData = new FormData();
      formData.append('data', JSON.stringify(this.form))
      formData.append('file', this.form.file)
      fetch(this.$store.state.url.URL_OUT_COME + "editData", {
          method: "POST",
          headers: {
            // "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: formData
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'lime-7', 'check_circle_outline');
          this.getView();
      });
    },

    editCatatan : function(){
      var formData = new FormData();
      formData.append('data', JSON.stringify(this.form))
      formData.append('file', this.form.file)
      fetch(this.$store.state.url.URL_OUT_COME + "editCatatan", {
          method: "POST",
          headers: {
            // "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: formData
      }).then(res_data => {
          this.Notify('Sukses Menambahkan Catatan', 'cyan-7', 'check_circle_outline');
          this.getView();
      });
    },

    editTte : function(){
      console.log("sampe kah");
      // var formData = new FormData();
      // formData.append('data', JSON.stringify(this.form))
      // formData.append('file', this.form.file_old)
      console.log(this.form);
      
      fetch(this.$store.state.url.URL_OUT_COME + "editTte", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(response => {
        console.log(response);
        
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
    })
    .then(data => {
      console.log(data);
      
        if (data.status_code != 200) {
          this.Notify(`Gagal Membubuhkan Tanda Tangan Elektronik, ${data.error}`, 'red-8', 'block');
          this.errorMessage = data.error;
        } else {
          this.Notify('Sukses Membubuhkan Tanda Tangan Elektronik', 'green-10', 'check_circle_outline');
        }
        this.getView();
    })
    .catch(error => {
        console.error("There was a problem with the fetch operation:", error);
        this.Notify('Gagal Membubuhkan Tanda Tangan Elektronik', 'red-8', 'block');
    });
},

    removeData : function(a, b){
      fetch(this.$store.state.url.URL_OUT_COME + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({id : a, file : b})
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'deep-orange-10', 'check_circle_outline');
          this.getView();
      });

    },

    selectData : function(data){
      console.log(data);
        this.form.id = data.id
        this.form.indikator = data.indikator
        this.form.file = this.form.file
        this.form.catatan = data.catatan
        // this.form.tahun = data.thn
        this.form.createAt = data.createAt
        this.form.file_old =  data.file
    },

    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },
        btn_prev : function(){
            this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },

    // ====================================== PAGINATE ====================================

  },

  mounted () {
    var get_profile = JSON.parse(localStorage.profile);

    console.log(get_profile);
            this.unitKerja = get_profile.profile.unit_kerja;
            this.unit_lppd = get_profile.profile.lppd;
            this.form.nik = get_profile.profile.nik;
            this.kode_jabatan = get_profile.profile.kode_jabatan;
            console.log(this.kode_jabatan);
            console.log(this.form.nik);
            
    this.getView();
    this.getTahun();
    this.getUnit();
  },
}
